export default __webpack_public_path__ + "static/media/img_background_slide_three.d365f3f2.png";